<template>
  <div>
    <v-data-table :headers="headers" :items="supervisorReviews">
      <template v-slot:item.id="{ item }">
        <span class="supervisor-review-table">{{ item["code"] }}</span>
      </template>
      <template v-slot:item.currentStage="{ item }">
        <span class="supervisor-review-table">{{ item["currentStage"] }}</span>
      </template>
      <template v-slot:item.employeeScore="{ item }">
        <span class="supervisor-review-table">{{ MyScore(item) }}%</span>
      </template>
      <template v-slot:item.overalScore="{ item }">
        <span class="supervisor-review-table">{{ OverallScore(item) }}%</span>
      </template>
      <template v-slot:item.documentStatus="{ item }">
        <v-chip
          v-show="item.documentStatus"
          small
          :color="getColor(item.documentStatus).color"
          dark
        >
          <span class="supervisor-review-table">{{
            item["documentStatus"]
          }}</span>
        </v-chip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn-toggle>
          <v-btn
            small
            color="primary"
            class="mx-2 white--text"
            tile
            link
            v-if="item.documentStatus === 'Reviewed'"
            @click="downloadEmployeeReport(item.code)"
          >
            <v-icon left color="white"> mdi-download </v-icon>
            report
          </v-btn>
          <v-btn
            small
            color="primary"
            tile
            :disabled="item.documentStatus === 'Reviewed' && tab !== '2nd'"
            :to="{
              name: 'Appraisal Card',
              params: { code: item.code },
            }"
          >
            {{
              tab === "2nd" && item.documentStatus === "Reviewed"
                ? "comment"
                : "Appraise"
            }}
            <v-icon right color="white">mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn
            small
            color="primary"
            tile
            :disabled="!['Reviewed', 'Submitted'].includes(item.documentStatus)"
            :to="{
              name: 'TrainingCard',
            }"
            class="ml-2"
          >
            Training Request
            <v-icon right color="white">mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn
            small
            color="info"
            tile
            class="ml-2"
            @click="openPeerDialog(item)"
          >
            Peers
            <v-icon right color="white">mdi-account-group</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-data-table>

    <v-dialog v-model="peerDialog" max-width="600px">
      <v-card v-if="selectedItem">
        <v-card-title>
          Manage Peers for {{ selectedItem.employeeName }}
          <v-spacer />
          <v-btn icon @click="peerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <PeerSelection :reviewID="selectedItem.code" canAddPeer />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppraisalMixin from "@/packages/cassandra-appraisal/modules/appraisalv3/AppraisalMixin";
import PeerSelection from "./PeerSelection.vue";

export default {
  name: "AppraisalSupervisorReviewTable",
  mixins: [AppraisalMixin],
  components: { PeerSelection },
  props: { supervisorReviews: Array, tab: String },
  data() {
    return {
      peerDialog: false,
      selectedItem: null,
      headers: [
        { text: "Code", align: "", sortable: true, value: "id" },
        {
          text: "Employee Name",
          align: "",
          sortable: true,
          value: "employeeName",
        },
        { text: "Stage", align: "", sortable: true, value: "currentStage" },
        {
          text: "Employee Score",
          align: "center",
          sortable: true,
          value: "employeeScore",
        },
        {
          text: "Final Score",
          align: "center",
          sortable: true,
          value: "overallScore",
        },
        { text: "Status", align: "", sortable: true, value: "documentStatus" },
        { text: "Actions", value: "action" },
      ],
    };
  },
  computed: {
    settings() {
      return this.$store.getters["Admin/adminGetters"]("settings");
    },
    hasTraining() {
      return this.settings && this.settings.site_installed_packages
        ? JSON.parse(this.settings.site_installed_packages).find(
            (item) => item.name === "Training"
          ) !== undefined
        : false;
    },
  },
  methods: {
    openPeerDialog(item) {
      this.selectedItem = item;
      this.peerDialog = true;
    },
    async downloadFile() {
      this.$store.dispatch("appraisal/getSupervisorReport", {
        reviewerID: this.userData.employee,
      });
    },
    async downloadEmployeeReport(item) {
      await this.$store.dispatch("appraisal/getAppraisalReport", {
        reviewNo: item,
      });
    },
  },
};
</script>
